// extracted by mini-css-extract-plugin
export default {"container":"AuthView_container__eJfR3","username":"AuthView_username__kWQPl","divider":"AuthView_divider__1NYlu","balance":"AuthView_balance__7D59x"};